import WelcomeContainer from '../../wrappers/WelcomeContainer'
import WritingPassword from '../../../ui-kit/static/images/stories/writing-password.svg'
import PasswordInput from '../../molecules/inputs/PasswordInput'

const NewPasswordForm = () => {
  return (
    <WelcomeContainer
      title="Nueva contraseña"
      subtitle="Tu nueva contraseña debe ser distinta a alguna que hayas usado con anteoridad"
      graphic={WritingPassword}
    >
      <PasswordInput label="Nueva contraseña" />
      <PasswordInput label="Repite la nueva contraseña" />
      <button className="button">Crea tu nueva contraseña</button>
    </WelcomeContainer>
  )
}

export default NewPasswordForm
